import React from 'react'
import {
  componentResolverFromMap,
  withPrismicPreview,
  withPrismicUnpublishedPreview,
} from 'gatsby-plugin-prismic-previews'
import { withPrismicPreviewPage } from '../contexts/prismic_preview'
import { linkResolver } from './link_resolver'

export const withPagePreview = (Page) =>
  withPrismicPreview(withPrismicPreviewPage(Page), prismicPreviewRepositoryConfigs)

export const withTemplatePreview = (Page) =>
  withPrismicPreview(
    withPrismicPreviewPage(
      withPrismicUnpublishedPreview(Page, prismicPreviewRepositoryConfigs),
    ),
    prismicPreviewRepositoryConfigs,
  )

export const prismicPreviewRepositoryConfigs = [
  {
    repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME || 'firststar-tech',
    linkResolver,
    componentResolver: componentResolverFromMap({
      blog: React.lazy(() => import('../templates/blog_post.js')),
      services: React.lazy(() => import('../templates/services.js')),
    }),
  },
]
